import React, { useState } from 'react';
import Select from 'react-select';

const AddUser = ({ isOpen, setIsOpen, showUserRate, setUserRate, userRate }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState(null); // For react-select

    // Options for the role select dropdown
    const roleOptions = [
        { value: "admin", label: "Admin" },
        { value: "staff", label: "Staff" },
        { value: "staff-assigned-customer", label: "Staff (Assigned Customer Only)" },
        { value: "timesheetstaff", label: "Timesheet Staff" },
    ];

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        if (!name || !email || !role) {
            alert("All fields are required.");
            return;
        }

        // Close modal and clear the form
        setIsOpen(false);
        setName("");
        setEmail("");
        setRole(null);
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Add User</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    {/* User Name */}
                    <div className="oms-form-group">
                        <label htmlFor="user-name" className="oms-form-label">
                            Name
                        </label>
                        <input
                            type="text"
                            id="user-name"
                            placeholder="Enter name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>

                    {/* User Email */}
                    <div className="oms-form-group">
                        <label htmlFor="user-email" className="oms-form-label">
                            Email
                        </label>
                        <input
                            type="email"
                            id="user-email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    {/* User Role */}
                    <div className="oms-form-group">
                        <label htmlFor="user-role" className="oms-form-label">
                            Role
                        </label>
                        <Select
                            id="user-role"
                            options={roleOptions}
                            placeholder="Select role"
                            value={role}
                            onChange={(selectedOption) => setRole(selectedOption)}
                            isClearable
                        />
                    </div>

                    {/* Per/Hour Rate */}
                    {showUserRate && (
                            <div className="oms-form-group">
                                <label htmlFor="userRate" className="oms-form-label">
                                    Rate/Hour [INR]
                                </label>
                                <input
                                    type="number"
                                    id="userRate"
                                    placeholder="Enter rate per hour"
                                    value={userRate}
                                    onChange={(e) => setUserRate(e.target.value)}
                                />
                            </div>
                        )}

                    {/* Actions */}
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Save</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddUser;